module.exports = __webpack_public_path__ + "static/media/logo-mocelin.7abb9712.png";